import React, { useEffect, useState } from "react";
import { getData } from "../services/api.service";
import { useNavigate, useParams } from "react-router-dom";
import { swalAlertDanger } from "../components/common/Alerts";
import Image from "../assets/img/H1.png";
import Logo from "../assets/img/Logo2.png";
import BottomNav from "../components/order_food/BottomNav";
import BackButton from "../components/common/BackButton";
import "../styles/HomePageOrder.css";

const HomePageOrder = () => {
  const navigate = useNavigate();
  const { branch_id } = useParams();
  const [burguerTypes, setBurguerTypes] = useState([]);
  const [statusBranch, setStatusBranch] = useState(null);
  const [branchInfo, setBranchInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      console.log("Cargando datos para sucursal:", branch_id); // Debug
      try {
        setLoading(true);

        const res = await getData(`/api/get_burguer_types/${branch_id}`);
        if (res.status === 200) {
          setBurguerTypes(res.data.burger_types);
        } else {
          swalAlertDanger(
            "Error al obtener los datos para realizar el pedido",
            "",
            () => {}
          );
        }

        // Obtener estado de la sucursal seleccionada
        const resBranch = await getData(
          `/api/admin/get_status_branch/${branch_id}`
        );
        if (resBranch.status === 200) {
          setStatusBranch(resBranch.data.branch);
          setBranchInfo(resBranch.data.branch[0]);
        } else {
          swalAlertDanger(
            "Error al obtener el estado de la sucursal",
            "",
            () => {}
          );
        }
      } catch (error) {
        swalAlertDanger("Error al obtener los datos", "", () => {});
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [branch_id]);

  return (
    <div className="home-page-container">
      <div className="header-section">
        <BackButton />
      </div>

      {/* Información de la sucursal */}
      {branchInfo && (
        <div className="branch-info-card">
          <div className="branch-header">
            <h2 className="branch-name">{branchInfo.branch_name}</h2>
            <div className="branch-status-indicator"></div>
          </div>
          <div className="branch-details">
            <div className="branch-detail-item">
              <span className="detail-icon">📍</span>
              <span className="detail-text">{branchInfo.address}</span>
            </div>
            {branchInfo.phone && (
              <div className="branch-detail-item">
                <span className="detail-icon">📞</span>
                <span className="detail-text">{branchInfo.phone}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="welcome-section">
        <h1 className="welcome-title">Llegó la hora de realizar tu pedido</h1>
        <p className="welcome-subtitle">¿Cuál Billy comemos hoy?</p>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : statusBranch?.[0]?.closed === 1 ? (
        <div className="alert alert-danger text-center my-5" role="alert">
          <h3 className="fw-bold">🔴 SUCURSAL CERRADA</h3>
          <p className="mb-0">
            Lo sentimos, actualmente no estamos recibiendo pedidos.
          </p>
          <small>Vuelve más tarde para hacer tu pedido.</small>
        </div>
      ) : (
        <div className="burger-cards-container">
          {burguerTypes.map((type) => (
            <div
              key={type.id}
              onClick={() => {
                navigate(
                  `/home/food_order/${branch_id}/burguer_type/${type.id}`
                );
              }}
              className="burger-card-horizontal"
              style={{ backgroundColor: type.background_color || "#198754" }}
            >
              <div className="burger-content">
                <div className="burger-text-section">
                  <h3 className="burger-title">
                    {type.type_description}
                  </h3>
                  {type.type_large_description && (
                    <p className="burger-description">
                      {type.type_large_description}
                    </p>
                  )}
                </div>
                <div className="burger-image-section">
                  <img
                    src={
                      type.photo_url
                        ? `${process.env.REACT_APP_API_URL}${type.photo_url}`
                        : Image
                    }
                    alt={type.type_description}
                    className="burger-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = Image;
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <img src={Logo} alt="LogoBottom" className="w-50 d-flex mx-auto mt-5" />

      <BottomNav id_branch={branch_id} />
    </div>
  );
};

export default HomePageOrder;
